import { render, staticRenderFns } from "./web-entrance-add.vue?vue&type=template&id=a385510c&scoped=true&"
import script from "./web-entrance-add.vue?vue&type=script&lang=js&"
export * from "./web-entrance-add.vue?vue&type=script&lang=js&"
import style0 from "./web-entrance-add.vue?vue&type=style&index=0&id=a385510c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a385510c",
  null
  
)

export default component.exports